import { useState } from 'react';
import { Button } from 'src/@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/@/components/ui/dialog';
import Iconify from 'src/components/Iconify';
import useAuth from 'src/hooks/useAuth';
import v2_actionCriarCanal from 'src/actions/v2/cliente/canais/v2_actionCriarCanal';
import ChannelCreationForm from './ChannelCreationForm';



export default function DialogNewChannel({
    open,
    onClose,
    onSubmit,
    canal
}) {

    const { cliente } = useAuth();

    const [channelData, setChannelData] = useState({
        nome: '',
        platform: 'whatsapp',
        webhook_type: ''
    });

    function handleChange(event) {
        const { name, value } = event.target;
        
        setChannelData(prev => ({
            ...prev,
            [name === 'channelName' ? 'nome' : 
             name === 'channelType' ? 'platform' : 
             name === 'webhookType' ? 'webhook_type' : name]: value
        }));
    }

    async function handleCreateChannel(data) {
        try {
            let requestData = {
                scope: {
                    nome: data.nome,
                    platform: data.platform,
                    webhook_type: data.webhook_type
                }
            }
            const response = await v2_actionCriarCanal(cliente._id, requestData)
            onSubmit(response.data.data._id);
        } catch (error) {
            console.error('Erro ao criar canal:', error);
        }
    }



    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">

                <div className="flex-1 overflow-auto">
                    <ChannelCreationForm
                        onSubmit={handleCreateChannel}
                        onChange={handleChange}
                        canal={channelData}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}


